import _ from 'lodash';

export const debounce = <T extends (...args: any) => any>(fn: T) => {
  return _.debounce(fn, 100, { leading: true, trailing: false });
};

export const buttonDebounce = <T extends (...args: any) => any>(fn: T) => {
  return _.debounce(fn, 100, { leading: true, trailing: true });
};
